export const BoundType = {
  IN: 'IN',
  OUT: 'OUT',
  values: () => {
    return ['IN', 'OUT'];
  },
};
